export const COLORS = {
  primary: '#0F4C81',
  primaryDark: '#0B3A63',
  primaryLight: '#2E6EA6',
  primaryPale: '#EAF3FB',
  primaryGhost: '#F3F8FD',

  secondary: '#2EA0FF',
  secondaryDark: '#1F7FD0',
  secondaryLight: '#6CBFFF',
  secondaryPale: '#E8F4FF',

  accent: '#173B66',
  accentGreen: '#1E9B63',
  accentBlue: '#2EA0FF',
  accentPink: '#D14B85',

  background: '#FFFFFF',
  backgroundGray: '#F9FAFB',
  backgroundDark: '#F3F4F6',

  text: '#111F2E',
  textSecondary: '#5B6472',
  textLight: '#8A94A5',

  border: '#DCE5EF',
  divider: '#EEF3F8',
  shadow: 'rgba(10, 27, 48, 0.08)',
};

export const THEME_TOKENS = {
  colorPrimary: COLORS.primary,
  colorInfo: COLORS.accentBlue,
  colorSuccess: COLORS.accentGreen,
  colorWarning: COLORS.secondary,
  colorError: '#EF4444',
  colorBgBase: COLORS.backgroundGray,
  colorBgContainer: COLORS.background,
  colorText: COLORS.text,
  colorTextSecondary: COLORS.textSecondary,
  borderRadius: 12,
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
};
